import React, { useState } from "react"
import { IMG } from "../../../common/CONST"
import { IReplenishmentDto } from "../../../../types/replenishment/IReplenishmentDto"

export const ReplenishmentErrorBlock: React.FC<{
  replenishment: IReplenishmentDto
  setReplenishment: (r: IReplenishmentDto) => void
  fieldName: string
}> = ({ replenishment, setReplenishment, fieldName }) => {
  const [visible, setVisible] = useState<any>(
    replenishment[fieldName as keyof IReplenishmentDto] && replenishment[fieldName as keyof IReplenishmentDto]
  )

  const ok = () => {
    setVisible(false)
    setReplenishment({ ...replenishment, [fieldName]: null })
  }

  if (replenishment.status !== "DOC") {
    return (
      <>
        {replenishment.contractorComment ? (
          <p className="message-course-no">{replenishment.contractorComment}</p>
        ) : (
          <></>
        )}
      </>
    )
  } else if (visible) {
    return (
      <>
        <div className="flex-row-10">
          <textarea
            className="message-input-error"
            onChange={e => setReplenishment({ ...replenishment, [fieldName]: e.target.value })}
            placeholder="Введите текст ошибки, при наличии"
            value={replenishment[fieldName as keyof IReplenishmentDto]?.toString()}
            style={{ resize: "none" }}
          />
        </div>
        <div className="flex-row-10">
          <button className="btn black-btn" onClick={ok}>
            <img src={IMG.ok_btn} alt="" />
            Всё верно
          </button>
        </div>
      </>
    )
  } else {
    return (
      <div className="flex-row-10">
        <button className="btn grey-btn" onClick={() => setVisible(true)}>
          Ошибка
        </button>
      </div>
    )
  }
}
